import { Button, FileUploader, LoadPanel } from "devextreme-react";
import { t } from 'i18next';
import { useRef, useState } from "react";
import { Config } from '@/core/config/config';
import { DataGrid, DataGridTypes, FilterRow, Pager, Paging, Scrolling } from 'devextreme-react/data-grid';

import { useNavigate } from 'react-router-dom';

function ExcelImport(props: any) {
    const { cardTitle, uploadUrl, templatePath } = props;
    const fileUploaderRef = useRef<FileUploader>(null);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [uploadedData, setUploadedData] = useState<any>();
    const [columns, setColumns] = useState<any>();
    const navigate = useNavigate();
    const position = { of: '#panel' };

    const allowedPageSizes: (DataGridTypes.PagerPageSize | number)[] = [10, 20, 50, 100, 200];

    const handleBack = () => {
        // Bir önceki sayfaya geri dönmek için history nesnesini kullanın
        navigate(-1)
    };
    const onBeforeSend = async (e: any) => {
        setLoadPanelVisible(true);
        e.request.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem(Config.VITE_APP_ACCESS_TOKEN_KEY as string))
    }

    const onUploaded = async (e: any) => {
        var response = JSON.parse(e.request.response);
        setUploadedData(response.searchResult);
        setColumns(Object.keys(response.searchResult));
        setLoadPanelVisible(false);
    }

    const onUploadError = async (e: any) => {
        console.log(e.error);
        setUploadedData([]);
        setColumns([]);
        setLoadPanelVisible(false);
    }
    return (
        <>
            <div id="panel">
                {/* <SingleCard title={t(cardTitle)}> */}
                    <div className="row justify-content-center">
                        <div className='col-auto mt-3 '>
                            <Button
                                text={t('back')}
                                type='normal'
                                icon='back'
                                onClick={handleBack}
                            />
                        </div>

                        <div className='col-auto mb-2'>

                            <FileUploader
                                ref={fileUploaderRef}
                                width={150}
                                selectButtonText={t("select_file")}
                                uploadButtonText={t("upload")}
                                showFileList={false}

                                labelText=""
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                uploadMode="instantly"
                                uploadUrl={uploadUrl}
                                onBeforeSend={onBeforeSend}
                                onUploaded={onUploaded}
                                onUploadError={onUploadError}
                                disabled={false}
                            />
                            <a href={templatePath}><i style={{ "fontSize": "14px" }} className='dx-icon dx-icon-download'></i>Excel Template</a>
                        </div>
                    </div >


                    <DataGrid
                        height={600}
                        allowColumnResizing={true}
                        dataSource={uploadedData}
                        defaultColumns={columns}
                        showBorders={true}
                showColumnLines={false}>
                        <Paging defaultPageSize={50} />
                        <Scrolling columnRenderingMode='virtual'  />
                        <FilterRow
                            visible={true}
                        />
                        <Pager
                    showNavigationButtons={true}
                            visible={true}
                            showInfo={true}
                            allowedPageSizes={allowedPageSizes}
                            showPageSizeSelector={true} />


                    </DataGrid>


                
            </div >
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={false}
                showPane={true}
                activeStateEnabled={false}
            />
        </>
    );
}

export default ExcelImport;